import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-hipaa-consent-authorization',
    templateUrl: './hipaa-consent-authorization.component.html',
    styleUrls: ['./hipaa-consent-authorization.component.scss'],
    encapsulation: ViewEncapsulation?.None,
    standalone: false
})
export class HipaaConsentAuthorizationComponent {



}
